<template>
  <div>
    <Banner />
    <div class="main-content">
      <div class="model-name">战略伙伴</div>
      <div class="model-name-en mb50">strategic partners</div>
      <el-row :gutter="20">
        <el-col :span="4.8" v-for="item in list" :key="item">
          <div class="brand-item">
            <img :src="item.brief" class="brand-image" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  loadYxTitle
} from '@/api/api'
import Banner from '../../components/Banner'
export default {
  components: {
    Banner
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      loadYxTitle().then(res => {
        var data = res.content.find(item => {
          return item.titleType == 4
        })
        if(data && data.articleTypeList.length > 0) {
          var detailList = data.articleTypeList[0].articleDetailList
          if(detailList) {
            this.list = detailList
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.brand-item {
  width: 220px;
  height: 120px;
  // background: #f8f8f8;
  background: #ffffff;
  margin-bottom: 40px;
}
.brand-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>